import { KibsiClient } from './base';
export class TimeKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'tenant');
    }
    async getTime(requestConfig) {
        const result = await this.get('time', requestConfig);
        return result.time;
    }
}
//# sourceMappingURL=time.js.map